module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            flipped: '=?',
            bundle: '='
        },
        link() {
        },
        template: require('./bundle-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/shelfproduct/bundle-directive.js
 **/